// extracted by css-extract-rspack-plugin
export default {"root":"A3mlH1iFWLAUBSw1","selectedOption":"YVBh2nQjiCMaVg8U","menuToggle":"YlH3yzYk4jowbD7S","menuRowContent":"LWMM3BsV5aM_Mj61","menuRowSelected":"aPjy8HIn98kHd58j"};